<div class="scaffold-sidebar-overlay">
  <div style="display:flex;">
    <div style="flex:1;">
      <div class="scaffold-editor-panel-heading">Properties </div>
      <div class="scaffold-editor-panel-sub-heading">
        {{settings[propertiesItem.type].Name}} Settings
      </div>
    </div>
    <div>
      <p-button variant="text" severity="contrast" size="large" (click)="setPropertiesSelection(null)" aria-label="Close properties panel"><i class="fas fa-times"></i></p-button>
    </div>
  </div>
  <hr />
  <div class="sidebar-scroll-area">    

    <app-controls [fileSet]="fileSet" *ngFor="let control of settings[propertiesItem.type].settings" [item]="control" [selectedItem]="propertiesItem || {} " [parentView]="parentView" (closeDialog)="optionsUpdate($event)" (setProperty)="updateOptions($event)"></app-controls>
    <app-controls [item]="tour" [selectedItem]="propertiesItem || {} " [parentView]="parentView" (closeDialog)="optionsUpdate($event)" (setProperty)="updateOptions($event)"></app-controls>
    <app-controls [item]="comments" [selectedItem]="propertiesItem || {} " [parentView]="parentView" (closeDialog)="optionsUpdate($event)" (setProperty)="updateOptions($event)"></app-controls>
    <app-controls [item]="disabled" [selectedItem]="propertiesItem || {} " [parentView]="parentView" (closeDialog)="optionsUpdate($event)" (setProperty)="updateOptions($event)"></app-controls>
    <app-controls [item]="hidden" [selectedItem]="propertiesItem || {} " [parentView]="parentView" (closeDialog)="optionsUpdate($event)" (setProperty)="updateOptions($event)"></app-controls>
  </div>
</div>
